<template>
  <div class="show">
    <div class="show_center" v-if="videoInfo">
      <!--左-->
      <div class="video_info">
        <div class="video_title">
          <div class="title">{{videoInfo.title}}</div>
          <div class="doctor_info">
            <span>讲解人:</span>
            <span>{{videoInfo.doctorName}}</span>
            <span>{{videoInfo.doctorLevelName}}</span>
            <span>{{videoInfo.hospitalName}}</span>
            <span>{{videoInfo.departmentName}}</span>
          </div>
        </div>
        <div class="video_infos">
          <div class="shiPin_box">
            <video :src="videoInfo.url" width="800px" height="455px" autoplay controls :poster="videoInfo.coverUrl" style=" object-fit: fill"></video>
          </div>
          <div class="video_time">
            <img src="../../../assets/images/home/u5999.png" alt="">
            <div>发布时间：{{videoInfo.publishTime}}</div>
          </div>
          <div class="video_text">{{videoInfo.content}}</div>
        </div>
        <div class="recommend">
          <div class="title">其它相关内容推荐</div>
          <div class="recommend_list">
            <div class="right_list_item" v-for="item in recommendList" :key="item.id" @click="handleTGoShow(item.id)">
              <div class="item_oneCard">
                <div class="oneCard_left">
                  <img :src="item.coverUrl" alt="">
                </div>
                <div class="oneCard_right">
                  <div class="header">{{item.title}}</div>
                  <div class="titles">
                    讲解人：
                    <div>{{item.doctorName}}</div>
                    <span>{{item.doctorLevelName}} </span>
                  </div>
                  <div class="time">发布时间：<span>{{item.publishTime}}</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--右-->
      <div class="hot_text">
        <div class="hot_btn">热点关注</div>
        <div class="hot_questions">
          <div class="questions_list" v-for="item in videoData" :key="item.id" @click="handleTGoShow(item.id)">
            <div class="classOne">
              <div class="img_box">
                <img :src="item.coverUrl" alt="">
              </div>
              <div class="doctor_info">
                <div class="info_title">
                  <img src="../../../assets/images/home/u1776.png" alt="">
                  <div>{{item.title}}</div>
                </div>
                <div class="info_name">
                  <div>{{item.doctorName}}</div>
                  <span>{{item.doctorLevelName}}</span>
                </div>
              </div>
            </div>
            <div class="classTwo">
              <img src="../../../assets/images/home/u1791.png" alt="">
              <div >{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        videoInfo:{},
        recommendList:[],
        videoData:[],
      }
    },
    methods:{
      // 获取详情信息
      getVideoShow() {
        let params = {
          id:this.$route.params.id
        }
        this.$api.mykp_home.findVideoShow(params) .then(res => {
          if(res.code == '000000') {
            this.videoInfo = res.infos
            this.getHotVideoList()
          }
        })
      },
      // 获取相关推荐列表
      getGoodList() {
        let params = {
          page:1,
          size:4,
          id:this.$route.params.id
        }
        this.$api.mykp_home.findGoodList(params) .then(res => {
          if(res.code == '000000') {
            this.recommendList  = res.infos
          }
        })
      },
      // 获取热门视频列表
      getHotVideoList() {
        const data = {
          type:3,
          doctorId:this.videoInfo.doctorId
        }
        this.$api.mykp_home.findDetailsHotlist(data) .then(res => {
          if(res.code == '000000'){
            this.videoData = res.infos
          }
        })
      },
      handleTGoShow(id) {
        this.$router.push({path:'/tt/kpVideo/kpVideoShow/'+id+'.html',query:{}})
      },
    },
    activated() {
      this.getVideoShow()
      this.getGoodList()
      var _hmt = _hmt || [];
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?26e3d1e8dc2b426ced392180fb72861b";
      var s = document.getElementsByTagName("script")[0]; 
      s.parentNode.insertBefore(hm, s);
      console.log("统计")
    },
    // 调用当前组件时调用
    beforeRouteUpdate (to, from, next) {
      next()
      this.getVideoShow()
      this.getGoodList()
      var _hmt = _hmt || [];
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?26e3d1e8dc2b426ced392180fb72861b";
      var s = document.getElementsByTagName("script")[0]; 
      s.parentNode.insertBefore(hm, s);
      console.log("统计")
    },
  }
</script>
<style lang="stylus" scoped>
  video{
    outline none
  }
  .show{
    margin-top 40px
    .show_center{
      width: 1200px
      margin 0 auto
      display flex
      justify-content space-between
      .video_info{
        width: 821px
        .video_title{
          &:after{
            content ''
            display flex
            width: 100%
            height: 1px
            background #d2d2d2
          }
          &:before{
            content ''
            display block
            clear both
          }
          .title{
            padding 0 30px
            font-weight: 700;
            font-style: normal;
            font-size: 20px;
            color: #333
            text-align: center
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .doctor_info{
            display flex
            float:right
            margin 20px 0 10px 0
            >span{
              font-size: 12px;
              color: #333
              margin-right 10px
            }
          }
        }
        .video_infos{
          margin-top 30px
          width: 100%
          .shiPin_box{
            display flex
            justify-content center
            >video{}
          }
          .video_time{
            display flex
            align-items center
            margin 15px 0
            padding-left 10px
            >img{
              width: 16px;
              height: 16px;
              margin-right 10px
              vertical-align middle
            }
            >div{
              font-size: 12px;
              color: #CCCCCC;
              transform translateY(1px)
            }
          }
          .video_text{
            font-size: 16px;
            line-height: 28px;
            color: #333
            text-indent 2em

          }
        }
        .recommend{
          .title{
            margin 40px 0 20px 0
            font-weight: 700;
            font-size: 16px;
            color: #333
          }
          .recommend_list{
            display flex
            flex-wrap wrap
            justify-content space-between
            .right_list_item{
              width: 401px
              margin-top 17px
              display flex
              align-items center
              cursor: pointer
              .item_oneCard{
                display flex
                flex-wrap wrap
                &:after {
                  content ''
                  display block
                  width: 361px
                  height: 1px
                  border-top 1px dashed #eee
                  margin-top 20px
                  transform translateY(-4px)
                }
                .oneCard_left{
                  >img{
                    width: 181px;
                    height: 127px;
                  }
                }
                .oneCard_right{
                  margin-left 20px
                  width: 185px
                  padding 20px 0
                  display flex
                  flex-direction column
                  .header{
                    max-width 200px
                    font-weight: 700;
                    font-size: 16px;
                    color: #333
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  .titles{
                    margin-top 15px
                    max-width 200px
                    display flex
                    font-weight: 700;
                    font-size: 14px;
                    color: #949494;
                    align-items center
                    >div{
                      font-size: 12px;
                      color: #949494;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      margin-right  10px
                    }
                    >span{
                      font-size: 12px;
                      color: #949494;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }
                  }
                  .time{
                    margin-top 20px
                    font-weight: 700;
                    font-style: normal;
                    font-size: 14px;
                    color: #949494;
                    >span{
                      font-size: 12px;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .hot_text{
        width: 361px
        height: 500px
        .hot_btn{
          width: 170px;
          height: 40px;
          background #1083f8
          border-radius: 5px;
          font-weight: 700;
          font-size: 18px;
          color: #FFFFFF;
          text-align: center
          line-height:40px
          margin-bottom 30px
        }
        .hot_questions{
          .questions_list{
            cursor: pointer
            .classOne{
              margin-bottom 25px
              display none
              align-items center
              .img_box{
                >img{
                  width: 100px;
                  height: 70px;
                  margin-right 10px
                }
              }

              .doctor_info{
                .info_title{
                  display flex
                  align-items top
                  >img{
                    width: 28px;
                    height: 20px;
                    margin-right 10px
                  }
                  >div{
                    font-size: 14px;
                    color: #FF7172;
                    line-height 20px
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                  }
                }
                .info_name{
                  margin-top 10px
                  display flex
                  align-items center
                  >div{
                    width: 100px
                    font-weight: 700;
                    font-style: normal;
                    font-size: 18px;
                    color: #000000;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  >span{
                    width: 180px
                    font-size: 14px;
                    color: #000000;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
              }
            }
            .classTwo{
              display flex
              align-items center
              margin-bottom 25px
              >img{
                width: 28px;
                height: 20px;
                margin-right 10px
              }
              >div{
                font-size: 14px;
                color: #5E5E5E;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            &:nth-child(-n + 3){
              .classOne{
                display flex
              }
              .classTwo{
                display none
              }
            }
            &:nth-child(3){
              &:after{
                content ''
                display block
                width: 100%
                height: 1px
                border-top 1px dashed #eee
                margin-bottom 25px
              }
            }
          }
        }
      }

    }
  }
</style>





// WEBPACK FOOTER //
// src/views/view-tt/kpVideo/Show.vue